"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SweetAlert_1 = __importDefault(require("./components/SweetAlert"));
exports.default = SweetAlert_1.default;
